<template>
  <div
    class="tw:hover:bg-blue-200 tw:w-full tw:text-gray-800 tw:p-3.5 tw:flex tw:justify-between tw:items-center"
    :class="{ 'tw:hover:cursor-pointer': !assigned || reassignable }"
    role="button"
    tabindex="0"
    @click="emit('onClick', id)"
    @keydown.enter.prevent="emit('onClick', id)"
    @keydown.space.prevent="emit('onClick', id)"
    :data-testid="`property-list-item-${id}`"
  >
    <div class="tw:flex tw:justify-start tw:items-center">
      <div class="tw:h-[40px] tw:overflow-hidden tw:w-[40px] tw:rounded tw:mr-3">
        <img
          :src="img"
          :alt="''"
          class="tw:h-[40px] tw:w-[40px] hotel-image"
          :class="{ 'tw:opacity-50': assigned && !reassignable }"
        />
      </div>
      <div>
        <p class="tw:text-base tw:font-bold" :class="{ 'tw:text-gray-500': assigned && !reassignable }">{{ name }}</p>
        <p class="tw:text-sm" :class="{ 'tw:text-gray-500': assigned && !reassignable }">{{ address }}</p>
        <p class="tw:text-xxs tw:text-gray-700">
          <span class="tw:font-bold">{{ 'ID: ' }}</span
          >{{ id }}
        </p>
      </div>
    </div>
    <div v-if="assigned && !reassignable">
      <p class="tw:text-gray-500 tw:text-xs">{{ $t('item_is_already_assigned') }}</p>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['onClick'])
defineProps({
  img: String,
  name: String,
  address: String,
  id: Number,
  assigned: Boolean,
  reassignable: Boolean,
})
</script>

<style scoped>
.hotel-image {
  height: 40px;
  object-fit: cover;
}
</style>
